import { css } from 'lit';

export default css`
  :host {
    aspect-ratio: 16 / 9;
    display: block;
    min-height: 180px;
    width: 100%;
  }

  .chart {
    height: 100%;
    width: 100%;
  }
`;
